import '@ui5/webcomponents/dist/SegmentedButton.js';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `SegmentedButton` shows a group of items. When the user clicks or taps one of the items, it stays in a pressed state. It automatically resizes the items to fit proportionally within the component. When no width is set, the component uses the available width.
 *
 * **Note:** There can be just one selected `item` at a time.
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/SegmentedButton" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const SegmentedButton = withWebComponent('ui5-segmented-button', ['accessibleName'], [], [], ['selection-change']);
SegmentedButton.displayName = 'SegmentedButton';
export { SegmentedButton };
